/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountExperienceTransactionType } from './AccountExperienceTransactionType';
import {
    AccountExperienceTransactionTypeFromJSON,
    AccountExperienceTransactionTypeFromJSONTyped,
    AccountExperienceTransactionTypeToJSON,
    AccountExperienceTransactionTypeToJSONTyped,
} from './AccountExperienceTransactionType';
import type { AccountExperienceTransactionSubject } from './AccountExperienceTransactionSubject';
import {
    AccountExperienceTransactionSubjectFromJSON,
    AccountExperienceTransactionSubjectFromJSONTyped,
    AccountExperienceTransactionSubjectToJSON,
    AccountExperienceTransactionSubjectToJSONTyped,
} from './AccountExperienceTransactionSubject';

/**
 * Represents a transaction in the account experience section.
 * @export
 * @interface AccountExperienceTransaction
 */
export interface AccountExperienceTransaction {
    /**
     * 
     * @type {string}
     * @memberof AccountExperienceTransaction
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof AccountExperienceTransaction
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof AccountExperienceTransaction
     */
    updatedAt: number;
    /**
     * 
     * @type {AccountExperienceTransactionSubject}
     * @memberof AccountExperienceTransaction
     */
    subject: AccountExperienceTransactionSubject;
    /**
     * 
     * @type {string}
     * @memberof AccountExperienceTransaction
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountExperienceTransaction
     */
    adminNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountExperienceTransaction
     */
    user: string;
    /**
     * 
     * @type {AccountExperienceTransactionType}
     * @memberof AccountExperienceTransaction
     */
    type: AccountExperienceTransactionType;
    /**
     * 
     * @type {number}
     * @memberof AccountExperienceTransaction
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof AccountExperienceTransaction
     */
    community?: string;
    /**
     * The ID of the Overwolf reward that triggered this transaction.
     * @type {string}
     * @memberof AccountExperienceTransaction
     */
    overwolfRewardId?: string;
    /**
     * The ID of the guild quest that triggered this transaction.
     * @type {string}
     * @memberof AccountExperienceTransaction
     */
    guildQuestId?: string;
}



/**
 * Check if a given object implements the AccountExperienceTransaction interface.
 */
export function instanceOfAccountExperienceTransaction(value: object): value is AccountExperienceTransaction {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function AccountExperienceTransactionFromJSON(json: any): AccountExperienceTransaction {
    return AccountExperienceTransactionFromJSONTyped(json, false);
}

export function AccountExperienceTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountExperienceTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'subject': AccountExperienceTransactionSubjectFromJSON(json['subject']),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'adminNotes': json['adminNotes'] == null ? undefined : json['adminNotes'],
        'user': json['user'],
        'type': AccountExperienceTransactionTypeFromJSON(json['type']),
        'amount': json['amount'],
        'community': json['community'] == null ? undefined : json['community'],
        'overwolfRewardId': json['overwolfRewardId'] == null ? undefined : json['overwolfRewardId'],
        'guildQuestId': json['guildQuestId'] == null ? undefined : json['guildQuestId'],
    };
}

export function AccountExperienceTransactionToJSON(json: any): AccountExperienceTransaction {
    return AccountExperienceTransactionToJSONTyped(json, false);
}

export function AccountExperienceTransactionToJSONTyped(value?: AccountExperienceTransaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'subject': AccountExperienceTransactionSubjectToJSON(value['subject']),
        'notes': value['notes'],
        'adminNotes': value['adminNotes'],
        'user': value['user'],
        'type': AccountExperienceTransactionTypeToJSON(value['type']),
        'amount': value['amount'],
        'community': value['community'],
        'overwolfRewardId': value['overwolfRewardId'],
        'guildQuestId': value['guildQuestId'],
    };
}

